import React from "react";
import { Overlay } from "../..";
import "./scss/index.scss";
export function PopupMessage(_ref) {
  var overlay = _ref.overlay;
  var _overlay$context$data = overlay.context.data,
      image = _overlay$context$data.image,
      title = _overlay$context$data.title,
      text = _overlay$context$data.text,
      content = _overlay$context$data.content;
  return React.createElement(Overlay, {
    context: overlay
  }, image && React.createElement("img", {
    src: image,
    className: "popup-message__image",
    alt: "icon"
  }), title && React.createElement("h4", {
    className: "popup-message__title"
  }, title), text && React.createElement("p", {
    className: "popup-message__text"
  }, text), content && React.createElement("div", {
    className: "popup-message__content"
  }, content));
}